import { render, staticRenderFns } from "./customerLayout.vue?vue&type=template&id=93271e6e&scoped=true&"
import script from "./customerLayout.vue?vue&type=script&lang=js&"
export * from "./customerLayout.vue?vue&type=script&lang=js&"
import style0 from "./customerLayout.vue?vue&type=style&index=0&id=93271e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93271e6e",
  null
  
)

export default component.exports